import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const AlertContainer = styled.div`
	position: relative;
	padding: 0.75rem 1.25rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-left-color: transparent;
	border-radius: 0.25rem;
`;
const AlertWarning = styled(AlertContainer)`
	color: #856404;
	background-color: #fff3cd;
	border-color: #ffeeba;
`;

const TestCaseWarningAlert = styled(AlertWarning)`
	margin-bottom: 0;
	height: 2vh;
	position: sticky;
	bottom: 0;
	text-align: center;
`;

interface TestCaseWarningAlertComponentProps {
	showAlert: boolean;
}

export const TestCaseWarningAlertComponent = ({ showAlert }: TestCaseWarningAlertComponentProps) =>
	showAlert ? (
		<TestCaseWarningAlert>
			<FormattedMessage id="testcasewarningalert.paragraph" />
		</TestCaseWarningAlert>
	) : (
		<></>
	);
